<i18n>
{
    "uk": {
        "defaultTitle": "Після проходження курсу ви зможете"
    },
    "en": {
        "defaultTitle": "After completing the course, you will be able to"
    }
}
</i18n>


<template>
    <IconList
        v-if="autoBlock || edit"
        ref="child"
        :block="autoBlock"
        :edit="edit"
        @openIconListEditor="$emit('openResultListEditor')"
    />
</template>


<script>
    import IconList from '~/components/creative-practice/course-landing/IconList.vue';

    import { useCourseLandingStore } from '~/stores/courseLanding';

    import blockPropertyObject from '~/mixins/course-landing/blockPropertyObject.js';

    export default {
        props: {
            block: Object,
            edit:  Boolean,
        },

        components: {
            IconList,
        },

        mixins: [
            blockPropertyObject,
        ],

        computed: {
            locale () {
                return this.courseLandingStore.locale;
            },

            courseLandingStore () {
                return useCourseLandingStore();
            },


            title () {
                return this.blockPropertyObject(this.block.title, 'text');
            },

            content () {
                return this.blockPropertyObject(this.block.content, 'items');
            },

            autoBlock () {
                const ownTitle   = this.title;
                const ownContent = this.content;

                if (!('items' in ownContent) && !this.edit) return false;

                let block     = this.$structuredClone(this.block);
                block.title   = this.$structuredClone(ownTitle);
                block.content = this.$structuredClone(ownContent);

                if (!ownTitle.text) block.title.text = this.$t('defaultTitle', this.locale);

                block.content.items = this.getItems(ownContent.items || []);

                return block;
            },
        },

        methods: {
            getItems (items) {
                return items.map(item => {
                    return Object.assign(item, {
                        icon: {
                            src: '/images/creative-practice/about-common/icon-result.svg',
                            width:  32,
                            height: 32,
                        },
                    });
                });
            },
        },
    }
</script>
